
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'
import {required, decimal} from 'vuelidate/lib/validators'
import PropositionOptionModel from '@/models/PropositionOptionModel'

@Component({
  components: {
    BaseFormContainer,
    CheckboxYesNo,
    SelectRef
  },
  validations: {
    form: {
      CODE_REF_TYPE_OPTION: {
        required
      },
      LIBELLE: {
        required
      },
      TEXTE: {},
      TARIF: {
        decimal
      },
      FORCEE: {}
    }
  }
})
export default class PropositionOptionForm extends BaseForm {
  model = PropositionOptionModel
}
